import { state as productState } from "./products/state"
import productMutations from "./products/mutations"
import productActions from "./products/actions"
import productGetters from "./products/getters"

export const store = {
    state: { ...productState },
    mutations: { ...productMutations },
    actions: { ...productActions },
    getters: { ...productGetters }
};

